import {
  ref,
  watch,
} from 'vue'
import { i18n } from '~i18n'


export function useDocumentTitle (newTitle: string = '') {
  const title = ref<string>(newTitle)

  function setDocumentTitle (newTitle: string): void {
    if (newTitle) {
      document.title = `${newTitle} - ${i18n.t('platform.title')}`
    } else {
      document.title = i18n.t('platform.title')
    }
  }

  watch(
    title,
    (newTitle, oldTitle) => {
      if (newTitle && newTitle !== oldTitle) {
        setDocumentTitle(newTitle)
      }
    },
    { immediate: true },
  )

  return { setDocumentTitle }
}
